import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { LoginModalService } from './../login/login-modal.service';
import { AuthService } from './auth.service';
import { defs } from '../../defs';

@Injectable()
export class AuthGuard implements CanActivate {
	constructor(private authService: AuthService, private loginModalService: LoginModalService) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		if (this.authService.isLoggedIn()) {
			return true;
		} else {
			localStorage.setItem(defs.previousUrl, state.url);
			this.authService.logout();
			this.loginModalService.open();
			return false;
		}
	}
}
